import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {FlexLayoutModule} from "@angular/flex-layout";

import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";

import {TrajectoryComponent} from "./trajectory.component";

@NgModule({
	declarations: [TrajectoryComponent],
	exports: [
		TrajectoryComponent
	],
	imports: [
		CommonModule,
		// DragDropModule,

		FlexLayoutModule,

		MatCardModule,
		MatIconModule,
		MatButtonModule
	]
})

export class TrajectoryModule {
}
